import * as React from "react";
import "./style/style.scss";
// import { IColumn } from 'public@type/index';
import InteractiveChatRoom from "./component/InteractiveChatRoom";
import * as cn from "classnames";
import { observer, inject } from "mobx-react";
import { action } from "pc@action/index";

interface IProps {
  store?: any;
}

interface IState {
  columnTarget: string;
  playTarget: number | null;
}
@inject("store")
@observer
export default class PublicSidebarComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      columnTarget: "liveInfo",
      playTarget: null
    };
  }

  public componentWillReceiveProps(next: any) {}

  public componentDidMount() {}

  public targetColumn = (e: any) => {
    const target: string = e.target.dataset.targetColumn;
    this.setState({ columnTarget: target });
  };

  public targetIndex = (e: any) => {
    const index = e.target.dataset.index;
    action.changePlaybackTarget(index);
    this.setState({
      playTarget: Number(index)
    });
  };

  public render() {
    const {
      columnList,
      liveInfo,
      liveTime,
      playbackStatus,
      thumbnails,
      playbackNames,
      interactiveType,
      joinLivePlayer,
      playbackIndex
    } = this.props.store;

    const { detail, title, address } = liveInfo;

    const { columnTarget } = this.state;

    return (
      <div className="interactive-cloumn">
        <div className="live__interactive-container">
          <ul className="live__interactive-bar">
            {Object.keys(columnList).map((e: string, i: number) => {
              return (
                <li
                  className={cn({
                    active: columnTarget === e
                  })}
                  key={i}
                  data-target-column={e}
                  id={e}
                  onClick={this.targetColumn}
                >
                  <span>{columnList[e]}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="interactive-container">
          <div
            className={cn("interactive__container", {
              active: columnTarget === "playback"
            })}
          >
            <InteractivePlayback
              title={title}
              playbackStatus={playbackStatus}
              thumbnails={thumbnails}
              playTarget={playbackIndex}
              playbackNames={playbackNames}
              targetIndex={this.targetIndex}
            />
          </div>

          <div
            className={cn("interactive__container", {
              active: columnTarget === "liveInfo"
            })}
          >
            <InteractiveLiveInfo
              joinLivePlayer={joinLivePlayer}
              interactiveType={interactiveType}
              title={title}
              liveTime={liveTime}
              detail={detail}
              address={address}
            />
          </div>

          <div
            className={cn("interactive__container", {
              active: columnTarget === "chatRoom"
            })}
          >
            <InteractiveChatRoom />
          </div>
        </div>
      </div>
    );
  }
}

// 直播 回放
const InteractivePlayback = (option: {
  title: string;
  playbackStatus: boolean;
  thumbnails: any[];
  playTarget: number | string | null;
  targetIndex: (e: any) => void;
  playbackNames: any[];
}) => {
  const { playbackStatus, thumbnails, playTarget, targetIndex, playbackNames, title } = option;
  return (
    <ul className="playback__container">
      {playbackStatus &&
        thumbnails.map((e: string, k: number) => {
          const count = k + 1 < 10 ? `0${k + 1}` : k + 1;
          return (
            <li
              onClick={targetIndex}
              key={k}
              data-index={k}
              className={cn("playback__item", {
                active: Number(playTarget) === k
              })}
            >
              <div className="playback__picture">
                <img src={e} alt="" />
              </div>
              <div className="playback__name">
                <h2>
                  {title} - {count}
                </h2>
                <p>{playbackNames[k]}</p>
              </div>
            </li>
          );
        })}
    </ul>
  );
};

// 直播 相关信息
const InteractiveLiveInfo = (option: {
  interactiveType: string;
  title: string;
  liveTime: string;
  detail: string;
  address: string;
  joinLivePlayer?: boolean;
}) => {
  const { interactiveType, title, liveTime, detail, address } = option;

  return (
    <div
      className={cn("interactive-live-info", {
        interactive__type: interactiveType === "mobile"
      })}
    >
      <div className="interactive-subject">
        <h1>{title}</h1>

        <div className="interactive--info--container">
          <p>
            时间:
            {liveTime}
          </p>
          <p>地点: {address}</p>
        </div>
      </div>
      <div className="interactive-particulars">
        <p>详情：</p>
        <pre>{detail}</pre>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pc/component/sidebar/index.tsx